// Module
var code = `<h2 ng-click="expanderController.toggle()"> <i class="fa fa-fw fa-chevron-{{ expanderController.open ? 'down' : 'right' }}"></i> <span translate>{{ expanderController.label }}</span> </h2> `;
// Exports
module.exports = code;